
<span class="countdown-timer" :class="{ 'error': distance < 60000, 'done': distance <= 0 }">
  <icon class="icon" name="schedule" />
  <span class="text">{{ countdownDisplay }}</span>
</span>
